import React from 'react';
import Popover from 'material-ui/Popover';
import ProgressMarkerIcon from 'components/pure/utils/icon/ProgressMarkerIcon';
import './ProgressMarkerWithTooltip.styl';

/**
   Progress marker specifically intended to be displayed 'inline'
   (overlayed over the progress bar itself)
   */
export default class ProgressMarkerWithTooltip extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }

  onMouseOverPopover = () => {
    this.setState({showTooltip: true});
  };

  onMouseLeavePopover = () => {
    this.setState({showTooltip: false});
  };

  render() {
    return (
      <div
        ref={r => (this.anchorEl = r)}
        onMouseOver={this.onMouseOverPopover}
        onMouseLeave={this.onMouseLeavePopover}>
        <ProgressMarkerIcon className="progress-bar-with-inline-markers" {...this.props} />
        {this.state.showTooltip && (
          <Popover
            className="destyle-popover"
            canAutoPosition={false}
            open={true}
            useLayerForClickAway={false}
            anchorEl={this.anchorEl}
            anchorOrigin={{
              horizontal: 'middle',
              vertical: 'top',
            }}
            targetOrigin={{
              horizontal: 'middle',
              vertical: 'bottom',
            }}>
            <div className="tooltip-container percentage-tooltip">
              <div className="ev-tooltip">
                <div className="tooltip-content">{this.props.formattedValue}</div>
              </div>
            </div>
          </Popover>
        )}
      </div>
    );
  }
}
